import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditUserInvitationPayload {
    settingId: string
    data: any
}

export interface IEditUserInvitationState {
    status: string
    data: any
    errors: any
}

const initialState: IEditUserInvitationState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editUserInvitation = createSlice({
    name: 'event-setting/edit-user-invitation',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditUserInvitationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editUserInvitationActions = editUserInvitation.actions
export default editUserInvitation.reducer
